/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Forbidden403 = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const COLORS = {
    darkPurple: "#21003D",
    purple: "#7400BF",
    gold: "#F2B441",
    gradient: "linear-gradient(135deg, #21003D, #7400BF)",
    textLight: "#f3e9ff",
  };

  return (
    <div
      style={{
        background: COLORS.gradient,
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "30px",
        fontFamily: "'Tajawal', 'Cairo', sans-serif",
        color: COLORS.textLight,
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <div
        style={{
          maxWidth: 500,
          width: "100%",
          background: "rgba(255,255,255,0.08)",
          border: "1px solid rgba(255,255,255,0.15)",
          borderRadius: 18,
          padding: "40px 30px",
          boxShadow: "0 8px 25px rgba(0,0,0,0.3)",
          backdropFilter: "blur(12px)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            fontSize: "5rem",
            fontWeight: "bold",
            color: COLORS.gold,
            marginBottom: "20px",
          }}
        >
          403
        </div>

        <h3
          style={{
            color: COLORS.gold,
            fontFamily: "'Cairo', sans-serif",
            fontSize: "1.8rem",
            marginBottom: "15px",
          }}
        >
          {isArabic ? "الوصول محظور" : "Access Forbidden"}
        </h3>

        <p
          style={{
            color: COLORS.textLight,
            opacity: 0.85,
            fontSize: "1rem",
            marginBottom: "30px",
          }}
        >
          {isArabic
            ? "عذراً، ليس لديك صلاحية للوصول إلى هذه الصفحة."
            : "Sorry, you don't have permission to access this page."}
        </p>

        <button
          onClick={() => navigate(-1)}
          style={{
            background: COLORS.gold,
            color: COLORS.darkPurple,
            border: "none",
            borderRadius: 10,
            padding: "12px 30px",
            fontSize: "1rem",
            fontWeight: "600",
            cursor: "pointer",
            boxShadow: "0 4px 15px rgba(242,180,65,0.4)",
            transition: "0.3s",
            marginRight: isArabic ? "0" : "10px",
            marginLeft: isArabic ? "10px" : "0",
          }}
          onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
        >
          {isArabic ? "رجوع" : "Go Back"}
        </button>

        <button
          onClick={() => navigate("/")}
          style={{
            background: "rgba(255,255,255,0.15)",
            color: COLORS.textLight,
            border: "1px solid rgba(255,255,255,0.3)",
            borderRadius: 10,
            padding: "12px 30px",
            fontSize: "1rem",
            fontWeight: "600",
            cursor: "pointer",
            transition: "0.3s",
          }}
          onMouseEnter={(e) =>
            (e.target.style.background = "rgba(255,255,255,0.25)")
          }
          onMouseLeave={(e) =>
            (e.target.style.background = "rgba(255,255,255,0.15)")
          }
        >
          {isArabic ? "الصفحة الرئيسية" : "Home"}
        </button>
      </div>
    </div>
  );
};

export default Forbidden403;
